var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 400,
    viewBox: "0 0 490 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 422.213,
    height: 350,
    transform: "translate(48.8936)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.908 350C341.365 350 419.563 271.801 419.563 175C419.563 78.1988 341.365 0 244.908 0C148.451 0 70.2524 78.1988 70.2524 175C70.2524 271.801 148.451 350 244.908 350Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.542 103.002C447.343 103.002 453.666 96.6789 453.666 88.8784C453.666 81.0779 447.343 74.7544 439.542 74.7544C431.742 74.7544 425.418 81.0779 425.418 88.8784C425.418 96.6789 431.742 103.002 439.542 103.002Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460.213 47.5399C465.54 47.5399 469.858 43.2214 469.858 37.8942C469.858 32.567 465.54 28.2485 460.213 28.2485C454.885 28.2485 450.567 32.567 450.567 37.8942C450.567 43.2214 454.885 47.5399 460.213 47.5399Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5392 112.993C63.8664 112.993 68.1849 108.674 68.1849 103.347C68.1849 98.0202 63.8664 93.7017 58.5392 93.7017C53.2121 93.7017 48.8936 98.0202 48.8936 103.347C48.8936 108.674 53.2121 112.993 58.5392 112.993Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.452 322.785C86.3452 322.785 94.3653 314.765 94.3653 304.871C94.3653 294.978 86.3452 286.958 76.452 286.958C66.5587 286.958 58.5386 294.978 58.5386 304.871C58.5386 314.765 66.5587 322.785 76.452 322.785Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_767_11829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.793 285.475H106.711C89.8528 285.475 76.4526 272.075 76.4526 255.217V95.7111C76.4526 78.8528 89.8528 65.4526 106.711 65.4526H383.793C400.651 65.4526 414.051 78.8528 414.051 95.7111V255.217C414.051 272.075 400.651 285.475 383.793 285.475Z",
    fill: "#4E5655"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.041 235.765H117.95C114.06 235.765 111.034 232.739 111.034 228.849C111.034 224.958 114.06 221.933 117.95 221.933H162.041C165.932 221.933 168.958 224.958 168.958 228.849C168.958 232.739 165.932 235.765 162.041 235.765Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.365 235.765H189.274C185.383 235.765 182.357 232.739 182.357 228.849C182.357 224.958 185.383 221.933 189.274 221.933H233.365C237.255 221.933 240.281 224.958 240.281 228.849C240.281 232.739 237.255 235.765 233.365 235.765Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.688 235.765H260.597C256.707 235.765 253.681 232.739 253.681 228.849C253.681 224.958 256.707 221.933 260.597 221.933H304.688C308.578 221.933 311.604 224.958 311.604 228.849C311.604 232.739 308.578 235.765 304.688 235.765Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.011 235.765H331.92C328.03 235.765 325.004 232.739 325.004 228.849C325.004 224.958 328.03 221.933 331.92 221.933H376.011C379.901 221.933 382.927 224.958 382.927 228.849C382.927 232.739 379.901 235.765 376.011 235.765Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M360.018 152.771C374.342 152.771 385.954 141.159 385.954 126.835C385.954 112.511 374.342 100.899 360.018 100.899C345.694 100.899 334.082 112.511 334.082 126.835C334.082 141.159 345.694 152.771 360.018 152.771Z",
    fill: "#F9BD63"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M325.868 152.872C340.192 152.872 351.804 141.26 351.804 126.936C351.804 112.612 340.192 101 325.868 101C311.544 101 299.933 112.612 299.933 126.936C299.933 141.26 311.544 152.872 325.868 152.872Z",
    fill: "#FD784C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.932 149.091H117.518C114.06 149.091 111.034 146.065 111.034 142.607V111.484C111.034 108.026 114.06 105 117.518 105H165.499C168.958 105 171.983 108.026 171.983 111.484V142.607C172.416 146.065 169.39 149.091 165.932 149.091Z",
    fill: "#C5C5C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M449.849 266.845C448.8 271.304 447.226 276.026 445.39 279.96C440.406 289.666 432.537 297.273 422.831 302.257C412.863 307.241 401.059 309.339 389.255 306.716C361.45 300.945 343.613 273.665 349.384 245.86C355.155 218.055 382.173 199.956 409.978 205.989C419.946 208.087 428.602 213.071 435.947 219.891C448.275 232.22 453.521 250.057 449.849 266.845Z",
    fill: "url(#paint0_linear_767_11829)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M416.011 251.894H404.207V240.09C404.207 237.729 402.371 235.63 399.748 235.63C397.387 235.63 395.289 237.467 395.289 240.09V251.894H383.485C381.124 251.894 379.025 253.73 379.025 256.353C379.025 258.976 380.862 260.812 383.485 260.812H395.289V272.616C395.289 274.977 397.125 277.075 399.748 277.075C402.109 277.075 404.207 275.239 404.207 272.616V260.812H416.011C418.372 260.812 420.47 258.976 420.47 256.353C420.47 253.73 418.372 251.894 416.011 251.894Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_767_11829",
    x: 0.665237,
    y: 27.5589,
    width: 489.173,
    height: 371.597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 37.8937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.8937
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_767_11829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_767_11829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_767_11829",
    x1: 348.253,
    y1: 256.351,
    x2: 451.019,
    y2: 256.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentEmpty);
export default __webpack_public_path__ + "static/media/payment-empty.dbfedba170c0a1bc55c543a0166fd90b.svg";
export { ForwardRef as ReactComponent };